module.exports = __webpack_public_path__ + "static/img/eighteen.32ce154e.svg";